import api from './api';

export const supportAPI = {
  // Public
  getMyTickets: () => api.get('/support/tickets/my-tickets'),
  createTicket: (data) => api.post('/support/tickets', data),
  trackTicket: (ticketNumber) => api.get(`/support/tickets/track/${ticketNumber}`),
  customerReply: (id, data) => api.post(`/support/tickets/${id}/reply`, data),
  closeTicket: (id) => api.post(`/support/tickets/${id}/close`),
  reopenTicket: (id) => api.post(`/support/tickets/${id}/reopen`),

  // Admin
  getTickets: (params) => api.get('/support/admin/tickets', { params }),
  getTicketDetails: (id) => api.get(`/support/admin/tickets/${id}`),
  updateStatus: (id, status) => api.patch(`/support/admin/tickets/${id}/status`, { status }),
  reassignTicket: (id, adminId) => api.patch(`/support/admin/tickets/${id}/assign`, { adminId }),
  adminReply: (id, data) => api.post(`/support/admin/tickets/${id}/reply`, data),
  getDashboard: (params) => api.get('/support/admin/dashboard', { params })
};
